import { intl } from '../intl';
export const getIntlString = (path: string, values?: Record<string, any>): string => intl.formatMessage({ id: path }, values);
